import React, {useState} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import {setCurrentStep, setSelectedServiceType} from '../OwnershipTransferSellerSlice';
import {OwnershipTransferPrivateSellerStep, ServiceType} from '../Constant/Constant';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText} from '../Reports/dwhReports';
import EasyTransferMessage from '../Shared/EasyTransferMessage';
import SelectList from 'app/Components/Shared/SelectList/SelectList';

const SelectServiceType = (props) => {
  const [error, setError] = useState(false);
  const generalSelectBoxOptions = [
    {value: ServiceType.Cellular, key: 'נייד', keyText: getMobileKeyText()},
    {value: ServiceType.StationaryLine, key: 'נייח', keyText: getStationaryKeyText()},
  ];

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: {...props.data, userDetails: props.userDetails},
        actionType: DwhActionType.SelectServicePage,
        messageText: DWHMessageText.SelectServicePageDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, []);

  function nextStep() {
    if (!props.data.selectedServiceType) {
      setError(true);
    } else {
      gaButtonClick();
      if (props.data.selectedServiceType == ServiceType.Cellular) {
        props.setCurrentStep(OwnershipTransferPrivateSellerStep.SelectCellularNumber);
      } else {
        props.setCurrentStep(OwnershipTransferPrivateSellerStep.SelectStationaryLineType);
      }
    }
  }

  function getMobileKeyText() {
    // Count direct Cellular subscriptions
    const directCellular = props.productsAndServices.productsBySubscriber.Cellular?.length || 0;

    // Count Cellular subscriptions within Bundle array
    const bundleCellular =
      props.productsAndServices.productsBySubscriber.Bundle?.reduce((count, bundle) => {
        return count + (bundle.cellularItem?.length || 0);
      }, 0) || 0;

    const cellularCount = directCellular + bundleCellular;

    if (cellularCount == 1) {
      return `מנוי אחד`;
    } else {
      return `${cellularCount} מנויים`;
    }
  }
  function getStationaryKeyText() {
    let services;
    if (
      props.productsAndServices.selfCareData.coreProducts.includes('Internet') ||
      props.productsAndServices.selfCareData.coreProducts.includes('InternetIsp')
    ) {
      services = 'אינטרנט';
    }
    if (props.productsAndServices.selfCareData.coreProducts.includes('TV')) {
      services = services ? `${window.Config.brand_Name_HE} TV | ` + services : `${window.Config.brand_Name_HE} TV`;
    }
    if (props.productsAndServices.selfCareData.coreProducts.includes('Mapa')) {
      services = services ? 'קו טלפון ביתי | ' + services : 'קו טלפון ביתי';
    }

    return services;
  }

  function gaButtonClick() {
    dwhGeneralReport({
      data: {...props.data, userDetails: props.userDetails},
      actionType: DwhActionType.SelectServicePage,
      messageText: DWHMessageText.SelectServicePageButtonClicked,
      status: DWHStatus.Ongoing,
    });
  }

  return (
    <div className='ownership-transfer-select-service-type ownership-transfer-step'>
      <div className='l-title'>העברת בעלות </div>
      <div className='m-title center'>איזה שירות אנחנו מעבירים?</div>
      <div>
        <SelectList options={generalSelectBoxOptions} onClick={(e) => props.setSelectedServiceType(e)} />

        <EasyTransferMessage />
      </div>

      <div className='continue-button'>
        {error && <div className='error center'>כדי להמשיך יש לבחור שירות</div>}
        <BtnSubmit onclick={nextStep} text={'המשך'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateSeller,
  productsAndServices: state.selfcarePage,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  setSelectedServiceType,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectServiceType);
